module.exports = __webpack_public_path__ + "img/red_065.796d8f2d.png";